import React, { useState, useEffect } from "react";
import imgBanner from "../../../assets/About/AboutBanner.webp";

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import { CoreValueData } from "../../../models/mockdata.js";
import { CoreValueCard } from "../../../components";
import { Icon } from "@iconify/react";
import { Swiper, SwiperSlide } from "swiper/react";
import img_1 from "../../../assets/About/about-corporate-1.webp";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { path } from "../../../utils/common/constant.js";
import { useNavigate } from "react-router-dom";
const fadeInUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0 },
};
const zoomIn = {
  hidden: { opacity: 0, scale: 0.5 },
  visible: { opacity: 1, scale: 1 },
};
const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

const About = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(null);
  const [icon, setshowIcon] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    setshowIcon(isExpanded ? true : false);
  };

  const { swiperRef } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const { ref: imgRef } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const [visibleSlide, setVisibleSlide] = useState(3);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1200 && window.innerWidth > 768) {
        setVisibleSlide(2);
      } else if (window.innerWidth < 768) {
        setVisibleSlide(1);
      } else {
        setVisibleSlide(3);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <div className="">
        <div className="w-full  h-[calc(100vh-132px)]  relative transition-all duration-1000 ease-in-out">
          <img
            className="w-full h-full absolute object-cover object-bottom  top-0 left-0"
            src={imgBanner}
          ></img>
          {/* <div className="flex flex-col w-[85%] max-w-[1140px] mx-auto justify-center h-full ">
            <div
              className="w-[40%] pv:max-md:w-[80%] bg-black bg-opacity-20 p-4 "
              style={{ zIndex: 2 }}
            >
              <div className="">
                <h1
                  className={"text-white ani_fadeInUpBanner"}
                  style={{
                    fontSize: "clamp(2rem, 4vw, 4.5rem)",
                  }}
                >
                  {t("AboutTitle")}
                </h1>
              </div>

              <p
                className="ani_fadeInUpBanner text-white w-full pv:max-ph:w-[80%] mt-[1.5rem]"
                style={{
                  fontSize: "clamp(1rem, 2.5vw, 1.25rem)",
                  wordWrap: "break-word",
                }}
              >
                {t("AboutSubtitle")}
              </p>
            </div>
          </div> */}
        </div>
      </div>

      {/* <motion.div
        initial="hidden"
        animate="visible"
        variants={fadeInUp}
        transition={{ duration: 0.3, delay: 0.3 }}
        className={
          "max-w-[1140px] qhd:max-w-[60%] mx-auto grid lg:grid-cols-2 gap-4 py-[100px] qhd:py-[150px] pvmax:max-dv:w-[85%] pb-[100px]"
        }
      >
        <div className={"w-full flex flex-col "}>
          <p className="text-primary qhd:text-[2rem]">
            {t("AboutTitle")}
          </p>
          <p
            className="pv:max-md:text-4xl lg:pr-4 qhd:text-[2.5rem]  text-[2.5rem] pb-[1.25rem] text-primary"
            style={{
              lineHeight: 1.25,

              paddingBottom: "1.25rem",
            }}
          >
            {t("Home_AboutUsTitle")}
          </p>
        </div>
        <div>
          <p
            className="text-[1rem] qhd:text-[1rem] whitespace-pre-line text-justify text-primary"
            style={{ lineHeight: 1.6 }}
          >
            {t("Home_AboutUsDescription")}
          </p>
        </div>
      </motion.div> */}
      <motion.div
        variants={fadeIn}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.3, delay: 0.2 }}
        className="grid grid-cols-2 pv:max-xl:grid-cols-1  pv:max-xl:gap-y-10  qhd:max-w-[60%] max-w-[1140px] w-[85%] mx-auto py-[100px]"
      >
        <div className="">
          {/* <p className="bg-secondary1 w-fit p-[6px]" style={{ margin: 0 }}>
            {t("about_title_top_vission")}
          </p> */}
          <p
            className="w-full text-[4rem] qhd:text-[4rem] pv:max-md:text-[3rem] text-primary"
            style={{ margin: 0, lineHeight: "1.4" }}
          >
            {t("about_title_vission")}
          </p>
          <p
            className="text-primary text-[1rem] qhd:text-[1rem]"
            style={{ margin: 0, lineHeight: "1.25" }}
          >
            {t("about_content_vision")}
          </p>
        </div>

        <div className="flex justify-end">
          <div>
            {/* <p className="bg-secondary1 w-fit p-[6px]" style={{ margin: 0 }}>
              {t("about_title_top_mission")}
            </p> */}
            <p
              className="w-full text-[4rem] qhd:text-[4rem]  pv:max-md:text-[3rem] text-primary"
              style={{ margin: 0, lineHeight: "1.4" }}
            >
              {t("about_title_mission")}
            </p>

            <p
              className="text-primary text-[1rem] qhd:text-[1rem]"
              style={{ margin: 0, lineHeight: "1.25" }}
            >
              {t("about_content_mission")}
            </p>
          </div>
        </div>
      </motion.div>
      <motion.div
        ref={swiperRef}
        variants={fadeInUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.5, delay: 0.3 }}
        className="ph:flex-row justify-between gap-4 pb-[4.375rem] max-w-[1140px] qhd:max-w-[60%] mx-auto w-[85%] flex-col "
      >
        <div className="">
          <p
            className="text-[4rem] qhd:text-[4rem] pv:max-md:text-[3rem] text-primary"
            style={{ fontWeight: 500 }}
          >
            {t("core_value")}
          </p>
          <p
            className="text-primary text-[1rem] qhd:text-[1rem]"
            style={{ margin: 0, lineHeight: "1.25" }}
          >
            {t("core_value_content")}
          </p>
        </div>
        <div className="flex gap-4 justify-end pv:max-ph:pt-10">
          <div className=" swiper-button-prev-custome p-2 bg-transparent border-[2px] border-primary hover:opacity-60 duration-300 flex justify-center items-center rounded-lg cursor-pointer">
            <Icon
              icon={"mingcute:arrow-left-line"}
              className="h-8 w-8 text-primary qhd:h-12 qhd:w-12"
            ></Icon>
          </div>
          <div className="swiper-button-next-custome p-2 bg-transparent  border-[2px]  border-primary hover:opacity-60 duration-300 flex justify-center items-center rounded-lg cursor-pointer">
            <Icon
              icon={"mingcute:arrow-right-line"}
              className="h-8 w-8  text-primary  qhd:h-12 qhd:w-12"
            ></Icon>
          </div>
          <button
            className=" flex items-center pv:max-md:px-4 pv:max-md:py-4 bg-secondary1 text-white px-[42px] py-[14px] rounded-lg w-fit hover:bg-opacity-60 transition-colors"
            onClick={() => {
              navigate("../" + path.common.ABOUTLIST);
            }}
          >
            <p className="">{t("about_viewall")}</p>
          </button>
        </div>
      </motion.div>

      <motion.div
        variants={fadeInUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.3 }}
      >
        <Swiper
          className="max-w-[1140px] qhd:max-w-[60%] myswipper mx-auto pv:max-ph:w-full z-30"
          slidesPerView={visibleSlide}
          spaceBetween={30}
          pagination={{ el: ".swiper-pagination", clickable: true }}
          navigation={{
            nextEl: ".swiper-button-next-custome",
            prevEl: ".swiper-button-prev-custome",
            clickable: true,
          }}
          autoplay={{
            delay: 7000,
            disableOnInteraction: false,
          }}
          loop={true}
          modules={[Pagination, Navigation, Autoplay]}
        >
          {CoreValueData.map((item, index) => {
            return (
              <div className="" key={index}>
                <SwiperSlide className="myswipper">
                  <CoreValueCard
                    title={t(item.title)}
                    content={t(item.content)}
                    img={item.img}
                  ></CoreValueCard>
                </SwiperSlide>
                ;
              </div>
            );
          })}
        </Swiper>
      </motion.div>

      <div className="max-w-[1140px] qhd:max-w-[60%] mx-auto py-10 qhd:py-32 ph:py-20 pvmax:max-dv:w-[85%]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 qhd:gap-12">
          <motion.div
            ref={imgRef}
            initial="hidden"
            variants={fadeIn}
            whileInView={"visible"}
            transition={{ duration: 0.2, ease: "easeInOut", delay: 0.3 }}
            className="flex flex-col"
          >
            <p className="text-[1rem] qhd:text-[1rem] text-primary mb-[13px] text-justify">
              {t("AboutOurCompany")}
            </p>
            {/* <p className="text-4xl text-primary pb-[20px]">
              {t("AboutAchievementTitle")}
            </p> */}
            <div className="flex flex-col gap-4 text-primary">
              {/* <p className="text-lg text-justify" style={{ lineHeight: 1.6 }}>
                {t("AboutAchievementContent_1")}
              </p>
              <p className="text-lg text-justify" style={{ lineHeight: 1.6 }}>
                {t("AboutAchievementContent_2")}
              </p> */}
              {/* <div className="flex justify-center items-center ">
                <div className="w-[85%] bg-[#666666] h-[1px]"></div>
              </div> */}
              <div className="grid grid-cols-2 sm:grid-cols-2 gap-4 qhd:gap-10">
                <div className="col-span-2">
                  <p className="text-2xl qhd:text-[1.5rem] ph:text-3xl text-secondary1 font-bold">
                    {t("AboutAchivementValue_1")}
                  </p>
                  <p className="text-[1rem] qhd:text-[1rem] text-primary text-justify">
                    {t("AboutAchivementKey_1")}
                  </p>
                </div>
                <div className="col-span-1">
                  <p className="text-2xl qhd:text-[1.5rem] ph:text-3xl font-bold text-secondary1">
                    {t("AboutAchivementValue_2")}
                  </p>
                  <p className="text-[1rem] qhd:text-[1rem] text-primary text-justify">
                    {t("AboutAchivementKey_2")}
                  </p>
                </div>
                <div className="col-span-1">
                  <p className="text-2xl qhd:text-[1.5rem] ph:text-3xl text-secondary1 font-bold">
                    {t("AboutAchivementValue_3")}
                  </p>
                  <p className="text-[1rem] qhd:text-[1rem] text-primary text-justify">
                    {t("AboutAchivementKey_3")}
                  </p>
                </div>
                {/* <div className="">
                  <p className="text-2xl ph:text-3xl text-secondary1 font-bold">
                    {t("AboutAchivementValue_4")}
                  </p>
                  <p className="text-sm text-primary">
                    {t("AboutAchivementKey_4")}
                  </p>
                </div>
                <div className="">
                  <p className="text-2xl ph:text-3xl text-secondary1 font-bold">
                    {t("AboutAchivementValue_5")}
                  </p>
                  <p className="text-sm text-primary">
                    {t("AboutAchivementKey_5")}
                  </p>
                </div> */}
              </div>
            </div>
          </motion.div>
          <motion.div
            ref={imgRef}
            initial="hidden"
            variants={zoomIn}
            whileInView={"visible"}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            className="relative rounded-xl w-full lg:w-[100%] mx-auto"
          >
            <img
              className="object-cover rounded-xl w-full"
              src={img_1}
              alt="Company"
            />
            <div className="hidden absolute bottom-24 right-14 xl:grid grid-cols-8 gap-2">
              {[...Array(64)].map((_, index) => (
                <div
                  key={index}
                  className="w-1.5 h-1.5 rounded-full bg-cyan-300 opacity-50"
                />
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default About;
